interface DocumentCategoryConfig {
    id: string
    iconSrc: string
    type: string
}

export const DOCUMENT_CATEGORIES: DocumentCategoryConfig[] = [
    {
        id: "shipments",
        iconSrc: "/desktop/icon-shipments.png",
        type: "shipment",
    },
    {
        id: "vendors",
        iconSrc: "/desktop/icon-vendors.png",
        type: "vendor",
    },
    {
        id: "quotes",
        iconSrc: "/desktop/icon-quotes.png",
        type: "quote",
    },
    {
        id: "addresses",
        iconSrc: "/desktop/icon-addresses.png",
        type: "addressBook",
    },
    {
        id: "salesOrders",
        iconSrc: "/desktop/icon-sales-orders.png",
        type: "salesOrder",
    },
    {
        id: "products",
        iconSrc: "/desktop/icon-products.png",
        type: "product",
    },
    {
        id: "contacts",
        iconSrc: "/desktop/icon-contacts.png",
        type: "contact",
    },
    {
        id: "knowledgeNotes",
        iconSrc: "/desktop/icon-knowledge-notes.svg",
        type: "knowledgeNotes",
    },
    {
        id: "knowledgeDocs",
        iconSrc: "/desktop/icon-knowledge-docs.svg",
        type: "knowledgeDocs",
    },
    {
        id: "templates",
        iconSrc: "/desktop/icon-knowledge-docs.svg",
        type: "documentTemplate",
    },
    {
        id: "workspace",
        iconSrc: "/desktop/icon-folder.png",
        type: "workspace",
    },
]
